// Finance module schema — moved to packages/finance/src/schema.ts
export {}
